import { render } from "./employee-department.vue?vue&type=template&id=14fddd5c"
import script from "./employee-department.vue?vue&type=script&lang=js"
export * from "./employee-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__